import { createI18n } from 'vue-i18n'

export const i18n = createI18n({
  locale: 'pt-BR',
  fallbackLocale: 'pt-BR',
  messages: {},
  globalInjection: true,
  legacy: false,
})

async function fetchLocale(url) {
  const response = await fetch(url, { credentials: 'omit' })
  return response.json()
}

export async function loadLocaleMessages(locale) {
  // Sempre carrega o inglês primeiro, se ainda não estiver carregado
  if (!i18n.global.availableLocales.includes('en-US')) {
    const data = await fetchLocale(window.context.i18n['en-US'])
    i18n.global.setLocaleMessage('en-US', data)
  }

  // Depois carrega o idioma solicitado, se necessário
  if (!i18n.global.availableLocales.includes(locale)) {
    const data = await fetchLocale(window.context.i18n[locale])
    i18n.global.setLocaleMessage(locale, data)
  }

  // Define o idioma atual
  i18n.global.locale.value = locale
}

window.i18n = i18n
